/**
 * Recharts `Bar` radius tuple `[topLeft, topRight, bottomRight, bottomLeft]`.
 * Stacked columns: only the top segment gets top rounding; lower segments square.
 * Stacked horizontal: only the outer segment gets end rounding; inner segments square.
 */
export const stackedBarRadius = (
  index: number,
  total: number,
  defaultRadius: number,
  isColumnChart: boolean,
): [number, number, number, number] => {
  if (total <= 1) {
    return isColumnChart
      ? [defaultRadius, defaultRadius, 0, 0]
      : [0, defaultRadius, defaultRadius, 0];
  }
  if (isColumnChart) {
    if (index === total - 1) return [defaultRadius, defaultRadius, 0, 0];
    return [0, 0, 0, 0];
  }
  if (index === total - 1) return [0, defaultRadius, defaultRadius, 0];
  return [0, 0, 0, 0];
};
